import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Card,
  CardBody,
  Col
} from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from './Step1';
import Step2 from './Step2';
import Instructions from './Instructions';
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getUserAdmin } from "../../../helpers/api_rombo_helper";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const EditUser = (props) => {

  const dispatch = useDispatch()
  const [step, setStep] = useState(1);
  const [name, setName] = useState(null);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [secondLastName, setSecondLastName] = useState(null);
  const [company, setCompany] = useState({});
  const [isRole, setIsRole] = useState(null);
  const { id } = useParams();
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] })
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    document.title = `${i18n.t("UserEdit")} - ${orgId}`;
  }, [orgId]);

  useEffect(() => {
    onGetUser()
  }, [dispatch, loading]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [dispatch, data, loading]);

  const onGetUser = () => {
    let arr = []
    getUserAdmin(token, id)
      .then((response) => {
        setName(response.full_name)
        setPhone(response.phone)
        setEmail(response.email)
        setLastName(response.last_name)
        setSecondLastName(response.second_last_name)
        setCompany({ label: response.partner_name, value: response.partner_id })
        response.is_staff && setIsRole("STAFF")
        response.is_customer_admin && setIsRole("ADMIN")
        response.is_customer_user && setIsRole("USER")
      })
      .catch((error) => {
        console.error("Error - getUserAdmin ", error)
      })
  }

  const switchStep = () => {
    switch(step){
      case 1:
        return <Step1
          setStep={setStep}
          step={step}
          setName={setName}
          setPhone={setPhone}
          setEmail={setEmail}
          id={id}
          name={name}
          phone={phone}
          email={email}
          token={token}
          lastName={lastName}
          secondLastName={secondLastName}
          company={company}
          isRole={isRole}
          setLastName={setLastName}
          setSecondLastName={setSecondLastName}
          setCompany={setCompany}
          infoUser={infoUser}
          setInfoUser={setInfoUser}
          setIsRole={setIsRole}
          setErrorAlert={setErrorAlert}
          setErrorAlertMessage={setErrorAlertMessage}
        />
        break;
      case 2:
        return <Step2
          token={token}
          step={step}
          setStep={setStep}
          name={name}
          phone={phone}
          email={email}
          id={id}
          lastName={lastName}
          secondLastName={secondLastName}
          company={company}
          infoUser={infoUser}
          setInfoUser={setInfoUser}
          isRole={isRole}
          setErrorAlert={setErrorAlert}
          setErrorAlertMessage={setErrorAlertMessage}
        />
      default:
        break;
    }
  }

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Users")}
            link="/users"
            breadcrumbItem={i18n.t("UserEdit")}
          />
          <Row>
            <Card>
              <CardBody>
                <Instructions step={step}></Instructions>
              </CardBody>
            </Card>
          </Row>
          <Col xxl={12} md={12} xs={12} className="">
            <AlertError
              showAlertError={errorAlert}
              setShowAlertError={setErrorAlert}
              textHeader={i18n.t("Error")}
              textBody={errorAlertMessage}
            />
          </Col>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default EditUser;
